export default "__VITE_ASSET__BhBmpM9k__"